import React, { useState, useEffect } from 'react';
import { Flex, Image } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import logo from '../assets/loadlogo.png';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const DelayedSpinner = ({ minDelay = 500 }) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldShow(true);
    }, minDelay);

    return () => clearTimeout(timer);
  }, [minDelay]);

  if (!shouldShow) {
    return null;
  }

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      zIndex="9999"
      backgroundColor="rgba(255, 255, 255, 0.9)"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Flex
        position="relative"
        width="100px"
        height="100px"
        justifyContent="center"
        alignItems="center"
      >
        {/* Logo au centre */}
        <Image
          src={logo}
          alt="Logo"
          width="60px"
          height="60px"
          objectFit="contain"
          position="absolute"
          zIndex="2"
        />
        
        {/* Cercle rotatif */}
        <Flex
          position="absolute"
          width="full"
          height="full"
          borderWidth="3px"
          borderColor="blue.500"
          borderRadius="full"
          animation={`${spin} 1s linear infinite`}
          borderStyle="solid"
          borderTopColor="transparent"
          borderRightColor="transparent"
        />
      </Flex>
    </Flex>
  );
};

export default DelayedSpinner;
